// extracted by mini-css-extract-plugin
module.exports = {"check":"styles-module__check___1z-zi"};